import { map } from 'lodash';
import http from '@/services/http-client';
import routes from '@/../config/env';

const { cronos } = routes;

export const bookEvent = async ({ eventId, isOfferedPreMatch = true, isOfferedLive = true }) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/book`,
      data: {
        eventId,
        isOfferedPreMatch,
        isOfferedLive,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const bookAllFeaturesEvent = async (eventId) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/all/book`,
      data: {
        eventId,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const unbookEvent = async (eventId) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/un-book`,
      data: {
        eventId,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const isBooked = (eventId) => http({
  method: 'get',
  url: `${cronos}/events/${eventId}`,
});

export const bookSameGameParlays = async ({
  eventId,
  isOfferedPreMatch,
  isOfferedLive,
}) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/sgp/book`,
      data: {
        eventId,
        isOfferedPreMatch,
        isOfferedLive,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const unbookSameGameParlays = async (eventId) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/sgp/un-book`,
      data: {
        eventId,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const isSameGameParlaysBooked = (eventId) => http({
  method: 'get',
  url: `${cronos}/events/sgp/${eventId}`,
});

export const bookPlayerProps = async ({
  eventId,
  isOfferedPreMatch,
  isOfferedLive,
}) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/player-props/book`,
      data: {
        eventId,
        isOfferedPreMatch,
        isOfferedLive,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const unbookPlayerProps = async (eventId) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/player-props/un-book`,
      data: {
        eventId,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const isPlayerPropsBooked = (eventId) => http({
  method: 'get',
  url: `${cronos}/events/player-props/${eventId}`,
});

export const bookMicroMarkets = async ({
  eventId,
  isOfferedPreMatch,
  isOfferedLive,
}) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/micro/book`,
      data: {
        eventId,
        isOfferedPreMatch,
        isOfferedLive,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const unbookMicroMarkets = async (eventId) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/micro/un-book`,
      data: {
        eventId,
      },
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const isMicroMarketsBooked = (eventId) => http({
  method: 'get',
  url: `${cronos}/events/micro/${eventId}`,
});

export const subscribe = ({ competitionId, isOfferedPreMatch = true, isOfferedLive = true }) => http({
  method: 'post',
  url: `${cronos}/subscriptions/subscribe`,
  data: {
    id: competitionId,
    isOfferedPreMatch,
    isOfferedLive,
  },
});

export const unsubscribe = (competitionId) => http({
  method: 'post',
  url: `${cronos}/subscriptions/un-subscribe`,
  data: {
    id: competitionId,
  },
});

export const isSubscribed = (competitionId) => http({
  method: 'get',
  url: `${cronos}/subscriptions/${competitionId}`,
});

export const subscribeSameGameParlays = ({
  competitionId,
  isOfferedPreMatch,
  isOfferedLive,
}) => http({
  method: 'post',
  url: `${cronos}/subscriptions/sgp/subscribe`,
  data: {
    id: competitionId,
    isOfferedPreMatch,
    isOfferedLive,
  },
});

export const unsubscribeSameGameParlays = (competitionId) => http({
  method: 'post',
  url: `${cronos}/subscriptions/sgp/un-subscribe`,
  data: {
    id: competitionId,
  },
});

export const isSameGameParlaysSubscribed = (competitionId) => http({
  method: 'get',
  url: `${cronos}/subscriptions/sgp/${competitionId}`,
});

export const subscribePlayerProps = ({
  competitionId,
  isOfferedPreMatch,
  isOfferedLive,
}) => http({
  method: 'post',
  url: `${cronos}/subscriptions/player-props/subscribe`,
  data: {
    id: competitionId,
    isOfferedPreMatch,
    isOfferedLive,
  },
});

export const unsubscribePlayerProps = (competitionId) => http({
  method: 'post',
  url: `${cronos}/subscriptions/player-props/un-subscribe`,
  data: {
    id: competitionId,
  },
});

export const isPlayerPropsSubscribed = (competitionId) => http({
  method: 'get',
  url: `${cronos}/subscriptions/player-props/${competitionId}`,
});

export const subscribeMicroMarkets = ({
  competitionId,
  isOfferedPreMatch,
  isOfferedLive,
}) => http({
  method: 'post',
  url: `${cronos}/subscriptions/micro/subscribe`,
  data: {
    id: competitionId,
    isOfferedPreMatch,
    isOfferedLive,
  },
});

export const unsubscribeMicroMarkets = (competitionId) => http({
  method: 'post',
  url: `${cronos}/subscriptions/micro/un-subscribe`,
  data: {
    id: competitionId,
  },
});

export const isMicroMarketsSubscribed = (competitionId) => http({
  method: 'get',
  url: `${cronos}/subscriptions/micro/${competitionId}`,
});

export const bulkBookEvents = async (events) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/book-list`,
      data: events,
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const bulkBookMicroMarkets = async (events) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/micro/book-list`,
      data: events,
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const bulkBookPlayerProps = async (events) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/player-props/book-list`,
      data: events,
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};

export const bulkBookSameGameParlays = async (events) => {
  try {
    const response = await http({
      method: 'post',
      url: `${cronos}/events/sgp/book-list`,
      data: events,
    });
    return response;
  } catch (e) {
    const error = new Error();
    error.statusCode = e.response?.status;
    error.messages = map(e.response?.data?.errors, (item) => item.detail);
    throw error;
  }
};
